import {BaseContainerModel} from "../../../base-container.model";
import {
    bl_alg_cc_rule_ext_RowClass, 
    bl_alg_cc_rule_hdr_RowClass, 
    bl_alg_cc_rule_hdr_RowInterface

}from "../../../../dbschema"

export class RuleContainerModel extends BaseContainerModel{
    bl_alg_cc_rule_hdr : bl_alg_cc_rule_hdr_RowInterface = new bl_alg_cc_rule_hdr_RowClass
    bl_alg_cc_rule_exts : bl_alg_cc_rule_ext_RowClass[] = []
}